module.exports = __webpack_public_path__ + "img/main-old.ed0055ba.png";